import React from "react";
import { Formik, Form, Field } from "formik";
import { Input } from "../../components/Input/Input";
import { LocationAddValidation } from "../../validators/LocationValidator";
import Button from "../../components/CustomButtons/Button";
import { Grid, makeStyles } from "@material-ui/core";
import { LocationService } from "../../services/LocationService";

const useStyles = makeStyles({
    buttonContainer: {
        textAlign: "center",
    },
});
export const AddLocation = ({
    startLoader,
    stopLoader,
    onSuccess,
    onClose,
}) => {
    const classes = useStyles();
    const handleSubmit = (values) => {
        LocationService.Create(
            values,
            () => startLoader("locationCreate"),
            locationCreateSuccess,
            locationCreateError,
            () => stopLoader("locationCreate")
        );
    };
    const initialValues = {
        locationName: "",
    };
    const locationCreateSuccess = (res) => {
        const data = res.data.data;
        onSuccess(data);
        onClose();
    };
    const locationCreateError = (err) => {
        console.log(err);
        onClose();
    };
    return (
        <Formik
            onSubmit={handleSubmit}
            validationSchema={LocationAddValidation}
            initialValues={initialValues}
        >
            <Form>
                <Grid container direction="column" spacing={3}>
                    <Grid item xs={12}>
                        <Field
                            component={Input}
                            name="locationName"
                            type="text"
                            fullWidth
                            label="Location"
                        />
                    </Grid>
                    <Grid item xs={12} className={classes.buttonContainer}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            mb={2}
                        >
                            Submit
                        </Button>
                    </Grid>
                </Grid>
            </Form>
        </Formik>
    );
};
